/* ce-media-filter.js — show only the media of the selected colour (alt-text tags), WITHOUT moving anything.
   The gallery renders every media in product order; `data-ce-color` marks the ones whose alt names a value of the
   filter option (section setting ce_media_filter_option) and the server hides the non-selected ones.
   On variant change Dawn's product-info.js syncs the list (identical here: same items, same order) then calls
   media-gallery.setActiveMedia(featured, prepend=true), which reorders the list and scrolls the slider AND the window
   to the featured media — Quentin: "no movement at all". That call is neutralised (prepend calls ignored; thumbnail
   clicks keep prepend=false); after `variantChange` this script re-applies the filter on both lists, keeps the current
   media when it is a shared one, and swaps a colour media for its counterpart of the new colour (same rank) in place.
   No window scroll ever; the mobile slider only jumps (instantly) when the new active media is not already in view. */
(function () {
  function items(gallery) {
    return Array.from(gallery.querySelectorAll('.product__media-item'));
  }
  function colorOf(item) {
    return String(item.dataset.ceColor || '').trim();
  }
  function shown(item) {
    return !item.classList.contains('ce-media-hidden');
  }

  function apply(gallery, color) {
    const wanted = String(color || '').toLowerCase().trim();
    const list = items(gallery);
    const current = list.find((li) => li.classList.contains('is-active'));
    const currentColor = current ? colorOf(current) : '';
    // rank of the current media among the shown items of its colour (before the switch)
    const rank = current && currentColor ? list.filter((li) => colorOf(li) === currentColor && shown(li)).indexOf(current) : -1;

    gallery.querySelectorAll('[data-ce-color]').forEach((el) => {
      el.classList.toggle('ce-media-hidden', wanted !== '' && colorOf(el) !== wanted);
    });
    gallery.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.initPages === 'function') slider.initPages();
    });

    // new active: a shared media stays; a colour media becomes its counterpart (same rank, else the nearest one)
    let target = current;
    if (current && currentColor && currentColor !== wanted) {
      const candidates = list.filter((li) => colorOf(li) === wanted && shown(li));
      target = candidates[Math.min(rank < 0 ? 0 : rank, candidates.length - 1)] || list.find(shown) || null;
    }
    if (!target || target === current) return;
    list.forEach((li) => li.classList.remove('is-active'));
    target.classList.add('is-active');
    const thumb = gallery.querySelector(`.thumbnail-list__item[data-target="${target.dataset.mediaId}"]`);
    if (thumb && typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumb);
    // mobile slider: only when the counterpart is not already in the visible slot (equal image counts keep it there)
    const viewer = target.parentElement;
    if (viewer && viewer.scrollWidth > viewer.clientWidth) {
      const left = target.offsetLeft;
      const fullyOut = left + target.offsetWidth <= viewer.scrollLeft || left >= viewer.scrollLeft + viewer.clientWidth;
      if (fullyOut) viewer.scrollTo({ left, behavior: 'auto' }); // partially visible = leave it exactly where it is
    }
  }

  // Patch the class itself as soon as it is defined: the first variant change must never reach the original
  // (instances are upgraded when the definition lands, possibly after this script ran).
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(() => {
      const proto = customElements.get('media-gallery').prototype;
      if (proto.__ceMediaFilterPatched) return;
      proto.__ceMediaFilterPatched = true;
      const original = proto.setActiveMedia;
      proto.setActiveMedia = function (mediaId, prepend) {
        if (prepend && parseInt(this.dataset.ceFilterIndex, 10)) return; // variant change: handled in place below
        return original.call(this, mediaId, prepend);
      };
    });
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const data = event && event.data;
    if (!data || !data.variant) return;
    const gallery = document.getElementById(`MediaGallery-${data.sectionId}`);
    if (!gallery) return;
    const index = parseInt(gallery.dataset.ceFilterIndex, 10);
    if (!index) return;
    const value = data.variant[`option${index}`];
    if (value !== undefined) apply(gallery, value);
  });
})();
